<div class="select-wrapper" [ngClass]="[color, size]">
  <label *ngIf="label" [ngClass]="{ error: errorMessage }">
    {{ label }}
    <span *ngIf="errorMessage"> - *{{ errorMessage }}</span>
  </label>
  <div tabindex="0" class="menu-wrapper" (click)="toggleMenu()" (keydown)="toggleMenu($event)">
    <span *ngIf="value || multipleValue?.length" class="value">{{ multiple ? multipleValue.join(', ') : value }}</span>
    <span *ngIf="!value && !multipleValue?.length" class="placeholder">{{ placeholder }}</span>
    <i class="fas fa-angle-down" [ngClass]="{ open: isOpen }"></i>
  </div>
  <div *ngIf="options.length" class="options-wrapper" [ngClass]="{ open: isOpen }">
    <span
      tabindex="0"
      *ngFor="let option of options"
      class="option"
      [ngClass]="{ selected: isOptionSelected(option) }"
      (click)="onOptionSelect(option)"
      (keydown)="onOptionSelect(option, $event)"
    >
      {{ option }}
    </span>
  </div>
</div>
